export interface IInverterTypeModel {
    name: string;
    code: string;
    productionPortalUrl: string;
    isMicroInverter: boolean;
}

export class InverterTypeModel implements IInverterTypeModel {
    name: string;
    code: string;
    inverterTypeId: number;
    productionPortalUrl: string;
    isMicroInverter: boolean;
}